import React from 'react';
import { NavLink } from 'react-router-dom';

const SignedOutLinks = (props) => {
  return (
    <>
      <ul className='ml-2'>
        <li className='list-none'><NavLink to='/signup'>Signup</NavLink></li>
        <li className='list-none'><NavLink to='/signin'>Login</NavLink></li>
      </ul>
    </>
  )
}

export default SignedOutLinks